module.exports = __webpack_public_path__ + "static/img/PK8.69fa3fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/PK8.jpg
// module id = LM6R
// module chunks = 0